import { Anchor } from '@phx/design-system';

import type { MedicationEquivalent } from '../../graphql/generated/graphql';

type DrugFamilyEquivalentLinksProps = {
    displayedItems: MedicationEquivalent[];
    handleClick: (id: string, name: string) => void;
};

export const DrugFamilyEquivalentLinks = ({
    displayedItems,
    handleClick,
}: DrugFamilyEquivalentLinksProps) => {
    return displayedItems.map((eq, idx) => (
        <Anchor key={eq.id} onClick={() => handleClick(eq.id, eq.name)}>
            {eq.name}
            {idx < displayedItems.length - 1 && ', '}
        </Anchor>
    ));
};
